import {ReactElement} from "react";
import logo from "../../assets/icons/brand/logo.svg";
import * as css from "./Whoops.module.scss";

export interface WhoopsProps {
    className?: string;
    whoopsMessage?: string;
    message?: string;
    button?: ReactElement;
}

export function Whoops(props: WhoopsProps): ReactElement {
    return <div className={`${css.whoops} ${props.className ?? ""}`}>
        <div className={`${css.infoWrapper} infoWrapper`}>
            <div><img src={logo} alt="vizibly logo"/></div>
            <h1 className={`${css.whoopsText} whoopsText`}>{props.whoopsMessage ?? "Whoops!"}</h1>
            <div className={`${css.messageText} messageText`}>{props.message ? props.message : "Something went wrong! We're working on it."}</div>
            {props.button ? <div>{props.button}</div> : <></>}
        </div>
    </div>;
}